import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadOrderLifetimeRuleEpic } from './_epics/loadOrderLifetimeRule.epic';
import { updateOrderLifetimeRuleEpic } from './_epics/updateOrderLifetimeRule.epic';
import { validateOrderLifetimeRuleEpic } from './_epics/validateOrderLifetimeRule.epic';
import { reloadOrderLifetimeRuleListEpic } from './_epics/reloadOrderLifetimeRule.epic';
import { exportOrderLifetimeRulesEpic } from './_epics/exportOrderLifetimeRules.epic';

export const orderLifetimeRuleEpic = safeCombineEpics(
  loadOrderLifetimeRuleEpic,
  updateOrderLifetimeRuleEpic,
  validateOrderLifetimeRuleEpic,
  reloadOrderLifetimeRuleListEpic,
  exportOrderLifetimeRulesEpic,
);
